import type { CSSProperties } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  rounded?: 'sm' | 'md' | 'lg' | 'pill';
  style?: CSSProperties;
  className?: string;
}

const radiusMap = { sm: '6px', md: '10px', lg: '16px', pill: '9999px' } as const;

export function Skeleton({ width, height = 16, rounded = 'sm', style, className }: Props) {
  return (
    <span
      className={`skeleton ${className ?? ''}`}
      style={{
        display: 'block',
        width: width ?? '100%',
        height,
        borderRadius: radiusMap[rounded],
        ...style,
      }}
      aria-hidden="true"
    />
  );
}
